import React, { useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { Sphere, Html } from '@react-three/drei'
import * as THREE from 'three';
import * as tf from '@tensorflow/tfjs';
// import chebyshevLP from './LP';
import itertools from './itertools';
import SignVector from './SignVector';


const Polytope = (props) => {
  const polytopeRef = useRef();

  const svs = [];
  for (let row of props.points.arraySync()) {
    let sv = []
    for (let c of row) {
      sv.push(c > 0 ? '+' : '-');
    }
    svs.push(sv);
  }

  // const N = props.points.arraySync()[0].length;
  // let key = 0;
  // let W = props.proj.arraySync();
  // let regions = [];
  // let feasible = [];
  // for (let each of itertools.subsetIdxs(N)) {
  //   let signvec = Array(N).fill('+');
  //   for (let e of each) {
  //     signvec[e] = '-';
  //   }
  //   const problem = chebyshevLP(each, W);
  //   const sol = window.highs.solve(problem);
  //   if ( sol['Status'] == 'Optimal' ) {
  //     let cs = sol['Columns'];
  //     let p = new THREE.Vector3(cs['x1']['Primal'], cs['x2']['Primal'], 0).normalize().multiplyScalar(10);
  //     let sp = {'scale': sol.ObjectiveValue,
  //               'position': p,
  //               'signvec': signvec
  //               };
  //     regions.push(sp);
  //     key++;
  //     feasible.push(true);
  //   }
  //   else {
  //     feasible.push(false);
  //   }
  // }

  let P = tf.matMul(props.points, props.proj).arraySync();

  return (
      <group ref={polytopeRef}>
          {P.map((row, rowIndex) => (
            <group key={rowIndex}>
              <Sphere args={[.018, 16, 16]} key={rowIndex} position={new THREE.Vector3(row[0], row[1], 0)}>
                  <meshStandardMaterial transparent color="#333"  opacity={props.feasible[rowIndex]? .95 : .2} />
              </Sphere>
              <SignVector className="signvec" text={svs[rowIndex]} colors={props.colors} position={new THREE.Vector3(row[0], row[1], 0)} opacity={props.feasible[rowIndex]? .95 : .2} />
            </group>
          ))}
      </group>
  );
}

export default Polytope;
